import { UserProfile, UserType } from '../services/interfaces';
import LocalStorageService from '../services/utils/LocalStorage';
/**
 * Hook to manage user profile state
 * Loads profile from localStorage and syncs to UserContext on mount
 */
const useProfileService = () => {
  const saveUserProfile = (userProfile: UserProfile): void => {
    LocalStorageService.setItem('userProfile', userProfile);
  }

  const getUserProfile = (): UserProfile | null => {
    return LocalStorageService.getItem<UserProfile>('userProfile');
  }

  const removeUserProfile = (): void => {
    LocalStorageService.removeItem('userProfile');
    LocalStorageService.removeItem('userType');
  }

  const saveUserType = (userType: UserType): void => {
    LocalStorageService.setItem('userType', userType);
  }

  const getUserType = (): UserType | null => {
    return LocalStorageService.getItem<UserType>('userType');
  }

  return {
    saveProfile: saveUserProfile,
    getProfile: getUserProfile,
    removeProfile: removeUserProfile,
    saveUserType,
    getUserType
  };
};

export default useProfileService;
